export const DRAWERS_TABLE_ROWS = 25;